












































import {
  Advisor,
  Component,
  Prop,
  Question,
  QuestionType,
  SectionType,
  Vue
} from "@zoovu/runner-browser-api";
import { QuestionHeadView } from "@zoovu/runner-web-design-base";
import { Getter, State } from "vuex-class";

@Component({
  name: "QuestionHeadView",
  mixins: [QuestionHeadView]
})
export default class QuestionHeadViewExtended extends Vue {
  @State
  advisor!: Advisor;

  @Prop()
  navigationType!: string;

  @Prop()
  question!: Question;

  @Getter
  shouldSkipCurrentQuestion!: () => boolean;

  get parsedInfoText(): string | boolean {
    if (this.navigationType === `QUESTIONNAIRE`) {
      if (!this.question.infoText) return false;
      const breakLineRegexp = /<br ?\/?>/gi;
      return this.question.infoText.replace(breakLineRegexp, "");
    }
    return true;
  }

  get shouldShowHint(): boolean {
    return (
      (this.question.questionType === QuestionType.CHECKBOX ||
        this.question.questionType === QuestionType.RADIO) &&
      this.navigationType !== SectionType.RESULTS_PAGE
    );
  }
}
